import { Icon } from "@iconify/react/dist/iconify.js";
import Marquee from "react-fast-marquee";
import React, { useState, useEffect } from "react";
import { api } from "../../../api/axios";
import { PATH_PAGE } from "../../../routes/paths";

export default function TopBar(props) {
  const [marqueeText, setMarqueeText] = useState(
    `&nbsp;&nbsp;Enrollment Now Open for 2025/2026 Academic year!!!&nbsp;&nbsp;
    Entrance Examination Dates: 5th of July, 2025. 9th of August, 2025. 23rd
    of August, 2025.&nbsp;&nbsp; Time:&nbsp; <span class="time m-0">9:00am</span> &nbsp; prompt.&nbsp;&nbsp; Venue:
    School Hall. Click &nbsp;<a href="${PATH_PAGE.jss1Admission}">here</a>
    &nbsp;for more info.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;`
  );

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await api.get("/settings");
        if (response.data && response.data.marqueeText) {
          setMarqueeText(response.data.marqueeText);
        }
      } catch (error) {
        console.error("Failed to load marquee text:", error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <Marquee className={props.style}>
      <Icon icon="streamline-emojis:bell" width="1.2em" height="1.2em" />
      <span dangerouslySetInnerHTML={{ __html: marqueeText }}></span>
    </Marquee>
  );
}


